import { LaminateCalculateBanner } from './laminate-calculate-banner';

export const LaminateCalculateBannerResult = LaminateCalculateBanner;
